// function toggleOverlay( action ) {
// 	const overlay = document.getElementById( 'overlay' );
// 	if ( action === "on" ) {
// 		overlay.classList.add( 'is-active' );
// 	}
// 	if ( action === "off" ) {
// 		overlay.classList.remove( 'is-active' );
// 	}
// 	if ( action === "toggle" ) {
// 		overlay.classList.toggle( 'is-active' );
// 	}
// }

function togglePullout( id, action ) {
	const pullOut = document.getElementById( id );
	if ( action === "on" ) {
		pullOut.parentNode.classList.add( 'is-active' );
		pullOut.parentNode.classList.remove( 'is-inactive' );
		return;
	}
	if ( action === "off" ) {
		pullOut.parentNode.classList.remove( 'is-active' );
		pullOut.parentNode.classList.add( 'is-inactive' );
		return;
	}
	if ( action === "toggle" ) {
		pullOut.parentNode.classList.toggle( 'is-active' );
		pullOut.parentNode.classList.toggle( 'is-inactive' );
		return;
	}
	// toggleOverlay( action )
}

; ( () => {
	// toggle main nav in mobile
	const toggleMenu = ( e ) => {

		if ( e.key === "Escape" || e.target.classList.contains( "overlay" ) || e.target.classList.contains( "closePullout" ) ) {
			e.preventDefault();
			togglePullout( 'pulloutNav_container', 'off' )
			togglePullout( 'pulloutContent_container', 'off' )
		}
		if ( e.type === 'click' && ( e.target.classList.contains( 'menu-toggle' ) || e.target.parentNode.classList.contains( 'menu-toggle' ) ) ) {
			e.preventDefault();
			togglePullout( 'pulloutNav_container', 'toggle' )
		}
	}

	// toggle  nav in desktop
	document.addEventListener( 'click', toggleMenu );
	document.addEventListener( 'keydown', toggleMenu );
} )();

